import PropTypes from 'prop-types';
import React from 'react';
import Container from '@mui/material/Container';
import styles from './styles.css';
import PublisherEditor from '../../containers/PublisherEditor';
import { PageTitle } from '../../components/PageTitle/PageTitle';
import { ReportSaveButton } from '../../components/ViewEditReport/ViewEditReport';

class PublisherEdit extends React.Component {
	constructor(props) {
		super(props);
		this.publisherEditorRef = React.createRef();
	}

	render() {
		const { id, siteId, placementId } = this.props.match.params;

		return (
			<div className={styles.pageContentWrapper}>
				<Container maxWidth="xl">
					<div className="flex flex-row gap-4 justify-between">
						<PageTitle backlink={{ href: '/accounts' }}>Account settings</PageTitle>
						<ReportSaveButton
							onSave={() => this.publisherEditorRef.current?.save()}
						/>
					</div>
					<PublisherEditor
						innerRef={this.publisherEditorRef}
						id={id}
						goToSiteId={siteId}
						goToPlacementId={placementId}
					/>
				</Container>
			</div>
		);
	}
}

PublisherEdit.propTypes = {
	match: PropTypes.object.isRequired,
};

PublisherEdit.defaultProps = {

};

export default PublisherEdit;
